import React__default from 'react';

/**
 * Render the table row containing the weekday names.
 *
 * @group Components
 * @see https://daypicker.dev/guides/custom-components
 */
function Weekdays(props) {
    return (React__default.createElement("thead", { "aria-hidden": true },
        React__default.createElement("tr", { ...props })));
}

export { Weekdays };
